import { SelectInput } from '@/shared/components/SelectInput';
import { useAppSettingsStore, useLanguageOptions } from '@/shared/lib';
import type { LanguageSelectOption } from '@/shared/types';
import { cn } from '@/shared/utils';
import { ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const UserLanguageSelectInput = () => {
  const { t } = useTranslation();

  const { getLanguage, setLanguage } = useAppSettingsStore();
  const language = getLanguage();

  const { languageOptions } = useLanguageOptions();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <SelectInput
      withChevron={false}
      align="end"
      value={language}
      options={languageOptions}
      open={isOpen}
      onOpenChange={setIsOpen}
      sideOffset={4}
      triggerClassName={'p-0 max-h-[4.2rem] min-w-[7.6rem] max-w-[7.6rem]'}
      selectContentClassname={'w-[24rem] min-w-[24rem] h-[12rem] p-[0.8rem]'}
      classNameViewport={
        'flex flex-col items-center max-w-[24rem] min-w-[22rem] h-[12rem] p-0 box gap-[0.8rem]'
      }
      customOptionsRender={customOption => {
        const option = customOption as LanguageSelectOption;
        return (
          <div
            key={`${option.value}_header_select_value`}
            onClick={() => {
              setIsOpen(false);
              setLanguage(option.value);
            }}
            className="flex items-center hover:bg-accent hover:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative cursor-default py-[1.2rem] pr-[0.8rem] pl-[0.8rem] text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 w-full max-w-full gap-[0.8rem] min-h-[4.8rem] h-[4.8rem] rounded-[1.2rem]">
            <div className="w-[3.2rem] h-[3.2rem] flex items-center justify-center">
              {option.icon != '' && (
                <img
                  src={option.icon}
                  className="size-[3.2rem] text-primary"
                  alt={''}
                />
              )}
            </div>

            <span className="headline4 text-primary flex-1">
              {t(`common.language.options.${option.code}`)}
            </span>
          </div>
        );
      }}
      renderSelected={customOption => {
        const option = customOption as LanguageSelectOption;
        return (
          <div
            className={cn(
              'flex flex-row items-center h-[4.2rem] pl-[1.6rem] hover:bg-primary hover:text-primary-foreground py-[0.9rem] dark:hover:bg-input/50  rounded-full headline4 shadow-none h bg-background dark:bg-background dark:text-primary gap-0 min-w-[7.6rem] w-full max-w-[7.6rem]',
              isOpen ? 'bg-stroke' : ''
            )}
            onClick={() => setIsOpen(!isOpen)}>
            <span className={'text-nowrap'}>
              {t(`common.language.shortOptions.${option.code}`)}
            </span>
            <ChevronDownIcon className={'size-[2.4rem] opacity-50'} />
          </div>
        );
      }}
    />
  );
};
